import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { useExercisePresetRecoil } from '#states/exercisePresetsState';
import { PlusButton } from '../AddButton';

export const ExercisePlus = () => {
  const { setExercisePresets } = useExercisePresetRecoil();

  const { setRecords } = useDashboardCharFormExerciseState();
  // 운동 추가
  const onAddExercise = () => {
    setExercisePresets(prev => ({
      ...prev,
      exercisePresetWorkout: [
        ...prev.exercisePresetWorkout,
        {
          exerciseTypeId: '',
          sets: [{ setType: 'REPWEIGHT', round: 1 }]
        }
      ]
    }));

    setRecords(prev => [
      ...prev,
      {
        exerciseKind: '',
        exerciseTypeId: '',
        sets: [{ setType: 'REPWEIGHT', round: 1 }]
      }
    ]);
  };

  return (
    <PlusButton
      text="운동 추가"
      onClick={onAddExercise}
      style={{ marginTop: '28px' }}
    />
  );
};
